$(function() {

    CustomEase.create("customEase", "0.19, 1, 0.22, 1");
    gsap.registerPlugin(Draggable);

    $(document).on("click", "[data-bottom-sheet]", function(e) {
        e.preventDefault();
        console.log('click');
        $('body').addClass('overflow-hidden');
        const sheetId = $(this).data("bottom-sheet");
        const $sheet = $(`[data-sheet-id="${sheetId}"]`);
        const $overlay = $("#overlay-bottom-sheet");

        $overlay.addClass("show");
        $sheet.addClass("show");

        gsap.to($sheet, {
            y: 0, 
            duration: 0.6,
            ease: "customEase",
        });

        Draggable.create($sheet.get(0), {
            trigger: $sheet.find(".drag-area").get(0),
            type: "y",
            bounds: {
                minY: ($sheet.height() * 1) + 50,
                maxY: -10
            },
            onDragEnd: function() {
                if (this.y > $sheet.height() * 0.1) {
                    gsap.to($sheet, {
                        y: ($sheet.height() * 1) + 50,
                        duration: 0.6,
                        ease: "customEase",
                    });

                    $overlay.removeClass("show");
                    $sheet.removeClass("show");
                    $('body').removeClass('overflow-hidden');
                } else {
                    gsap.to($sheet, {
                        y: 0,
                        duration: 0.6,
                        ease: "customEase" 
                    });
                }
            }
        });
    })

    $(document).on("click", "#overlay-bottom-sheet", function() {
        const $overlay = $(this);
        const $sheet = $(".bottom-sheet.show");

        gsap.to($sheet, {
            y: ($sheet.height() * 1) + 50,
            duration: 0.6,
            ease: "customEase",
        });

        

        $overlay.removeClass("show");
        $sheet.removeClass("show");
        $('body').removeClass('overflow-hidden');
    });


    const next = $('#swiper-medidas .swiper-button-next').get(0); 
    const prev = $('#swiper-medidas .swiper-button-prev').get(0); 
    const swiper = new Swiper('#swiper-medidas', {
         breakpoints: {
            0: {
                spaceBetween: 15,
                slidesPerView: 2,
            },  
            768: {
                slidesPerView: 3,
                spaceBetween: 15,
            }
          },
        navigation: {
            nextEl: next,
            prevEl: prev,
        },
    });


      function initSizeTable(
      tableUrl,
      tableId,
      slidesDesktop = 5,
      slidesTablet = 5,
      slidesMobile = 2
  ) {
      let wheelSwiper = null;
      const root = document.querySelector(`#${tableId}`);
      if (!root) {
          console.error(`Table root #${tableId} not found`);
          return;
      }

      if (!tableUrl) {
          console.error("No TABLE_URL provided");
          return;
      }

      fetch(tableUrl)
          .then((response) => response.arrayBuffer())
          .then((data) => {
              const workbook = XLSX.read(data, { type: "array" });
              const firstSheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[firstSheetName];
              const jsonData = XLSX.utils.sheet_to_json(worksheet, {
                  header: 1,
              });

              // Principal column
              const $principalColumn = $(root).find(".principal-column");
              $principalColumn.empty();

              jsonData.forEach((row) => {
                  const value = row[0];
                  if (value !== undefined && value !== null && value !== "") {
                      $principalColumn.append($("<div></div>").text(value));
                  }
              });

              // Swiper wrapper
              const $swiperWrapper = $(root).find(".swiper-wrapper");
              $swiperWrapper.empty();

              const maxColumns = Math.max(...jsonData.map((row) => row.length));

              for (let colIndex = 1; colIndex < maxColumns; colIndex++) {
                  const $slide = $('<div class="swiper-slide"></div>');
                  const $inner = $('<div class="column-inner"></div>');

                  jsonData.forEach((row) => {
                      const cell = row[colIndex];
                      $inner.append($("<div></div>").text(cell ?? ""));
                  });

                  $slide.append($inner);
                  $swiperWrapper.append($slide);
              }

              return true;
          })
          .finally(() => {
              $(`#${tableId} .swiper-container-table`).each(function (
                  _,
                  element
              ) {
                  const $element = $(element);
                  const slideCount = $element.find(".swiper-slide").length;

                  // Determinar dinámicamente según el parámetro
                  const finalSlidesDesktop =
                      slideCount < slidesDesktop ? slideCount : slidesDesktop;

                  const finalSlidesTablet =
                      slideCount < slidesTablet ? slideCount : slidesTablet;

                  const finalSlidesMobile =
                      slideCount < slidesMobile ? slideCount : slidesMobile;

                  const swiper = new Swiper($element.find(".swiper").get(0), {
                      loop: false,
                      breakpoints: {
                          0: {
                              slidesPerView: finalSlidesMobile,
                              spaceBetween: 0,
                          },
                          767: {
                              slidesPerView: finalSlidesTablet,
                              spaceBetween: 0,
                          },
                          993: {
                              slidesPerView: finalSlidesDesktop,
                              spaceBetween: 0,
                          },
                      },
                      on: {
                          init(swiper) {
                              toggleScrollBar(swiper, $element);
                          },
                          resize(swiper) {
                              toggleScrollBar(swiper, $element);
                          },
                          progress(swiper, progress) {
                              if (progress >= 0) {
                                  const barContainer = $element.find(
                                      ".scroll-custom-bar-container"
                                  );
                                  const bar =
                                      $element.find(".scroll-custom-bar");

                                  bar.css(
                                      "transform",
                                      `translateX(${
                                          progress * barContainer.width() -
                                          157 * progress
                                      }px)`
                                  );
                              }
                          },
                          reachEnd() {
                              $element.addClass("reach-end");
                          },
                          fromEdge() {
                              $element.removeClass("reach-end");
                          },
                      },
                  });

                  function toggleScrollBar(swiper, $element) {
                      if (swiper.isLocked) {
                          $element
                              .find(".scroll-custom-bar-container")
                              .addClass("d-none");
                      } else {
                          $element
                              .find(".scroll-custom-bar-container")
                              .removeClass("d-none");
                      }
                  }

                  // Wheel swiper setup
                  $(swiper.el).hover(
                      () => {
                          if (!wheelSwiper) {
                              wheelSwiper = new WheelSwiper({
                                  element: swiper.el,
                                  rightCallback: () => swiper.slideNext(),
                                  leftCallback: () => swiper.slidePrev(),
                              });
                          }
                      },
                      () => {
                          if (wheelSwiper) {
                              wheelSwiper.destroy();
                              wheelSwiper = null;
                          }
                      }
                  );
              });
          })
          .catch((error) => {
              console.error("Error loading table:", error);
          });
  }


    initSizeTable(
        window.TABLE_CONVERSION_CLOTHING_URL,
        "size-global-conversion"
    );

    initSizeTable(
        window.TABLE_SIZE_GUIDE_CM_URL,
        "size-guide-clothing-cm"
    );

    initSizeTable(
        window.TABLE_SIZE_GUIDE_IN_URL,
        "size-guide-clothing-in"
    );

    initSizeTable(
        window.TABLE_CONVERSION_FOOTWEAR_URL,
        "size-global-conversion-footwear",
        slidesTablet = 6,
        slidesMobile = 6,
    );

});

